module.exports = __webpack_public_path__ + "img/auth-banner.f29542c9.png";